import { CONFIGURATOR_SELECT, CONFIGURATOR_STORE_OPTION_NAME } from '../Actions/Configurator.action';

const defaultState = {
    selectedCombinedConfiguratorKeys: [],
    optionNames: []
}

export const configurator = (state = defaultState, action) => {
    switch (action.type) {            
        case CONFIGURATOR_SELECT:
            return {                
                ...state,
                selectedCombinedConfiguratorKeys: action.payload,
            };            
        default:
            return state;
    }
}